import { createAction, createReducer, on } from '@ngrx/store';
import * as DataSourceActions from './datasource.actions';
import * as AuthenticationActions from 'libs/authentication/src/lib/state/authentication.actions';
export const datasourceFeatureKey = 'dataSource';

export interface DatasourceState {
  data: any;
  loading: boolean;
  error: {
    timestamp?: number;
    key?: string;
    error?: unknown;
  };
}

export const initialState: DatasourceState = {
  data: null,
  loading: false,
  error: {}
};

const UpdateAuthenticationTokenWithProjectIdSuccessful = createAction(AuthenticationActions.ActionTypes.UpdateAuthenticationTokenWithProjectIdSuccessful);
const Logout = createAction(AuthenticationActions.ActionTypes.Logout);

export const reducer = createReducer(
  initialState,
  on(DataSourceActions.GetDataSources, (state) => ({
    ...state,
    loading: true
  })),
  on(DataSourceActions.GetDataSourcesSuccessful, (state, action) => ({
    ...state,
    data:action.payload.datasources
  })),
  on(DataSourceActions.GetDataSourcesFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload.error
  })),
  on(UpdateAuthenticationTokenWithProjectIdSuccessful, () => (initialState)),
  on(Logout, () => (initialState))
);
